import {createDeleteMethod, createGetAllMethod, createPostMethod, createPutMethod,} from "../core/factory";
import {entityType} from "./module";

export const getAllTags = () => createGetAllMethod(entityType)
export const deleteTag = (payload) => createDeleteMethod(entityType, payload)
export const createTag = (payload) => createPostMethod(entityType, payload)
export const updateTag = (payload) => createPutMethod(entityType, payload)
